import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const GET_FUNKTIONSBEREICH_FREIGABE = '[BenutzerverwaltungModul] GetFunktionsbereichFreigabe laden';
export const GET_FUNKTIONSBEREICH_FREIGABE_AUSFUEHREN = '[BenutzerverwaltungModul] GetFunktionsbereichFreigabe ausführen';
export const GET_FUNKTIONSBEREICH_FREIGABE_ERFOLGREICH = '[BenutzerverwaltungModul] GetFunktionsbereichFreigabe laden erfolgreich';
export const GET_FUNKTIONSBEREICH_FREIGABE_FEHLER = '[BenutzerverwaltungModul] GetFunktionsbereichFreigabe Ladefehler';
export const GET_FUNKTIONSBEREICH_FREIGABE_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] GetFunktionsbereichFreigabe nicht ausgeführt (evtl. Offline)';


export class GetFunktionsbereichFreigabeAction implements Action {
    readonly type = GET_FUNKTIONSBEREICH_FREIGABE;
        constructor( public funktionsbereich_id:string , public optPayload: any = null) {}
    }
export class GetFunktionsbereichFreigabeAusfuehrenAction implements Action {
    readonly type = GET_FUNKTIONSBEREICH_FREIGABE_AUSFUEHREN;
        constructor( public funktionsbereich_id:string , public optPayload: any = null) {}
    }
export class GetFunktionsbereichFreigabeErfolgreichAction implements Action {
    readonly type = GET_FUNKTIONSBEREICH_FREIGABE_ERFOLGREICH;
        constructor(public payload: api.FunktionsbereichFreigabe,  public funktionsbereich_id:string , public optPayload: any = null) {}
    }
export class GetFunktionsbereichFreigabeFehlerAction implements Action {
    readonly type = GET_FUNKTIONSBEREICH_FREIGABE_FEHLER;
        constructor(public payload: any,  public funktionsbereich_id:string , public optPayload: any = null) {}
    }
export class GetFunktionsbereichFreigabeNichtAusgefuehrtAction implements Action {
    readonly type = GET_FUNKTIONSBEREICH_FREIGABE_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungQueryFunktionsbereichFreigabeActions =
    GetFunktionsbereichFreigabeAction
    | GetFunktionsbereichFreigabeAusfuehrenAction
    | GetFunktionsbereichFreigabeErfolgreichAction
    | GetFunktionsbereichFreigabeFehlerAction
    | GetFunktionsbereichFreigabeNichtAusgefuehrtAction
    ;
